import React from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { useState, useEffect } from "react";
function ChairmanMessage() {
  useEffect(() => {
    document.title = "Chairman Message -  Gayatri International School";
  }, []);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const msgdata = await getPrincipalMessage();
        const data = msgdata.filter(
          (item) =>
            item.school === "FARRUKHABAD" && item.category === "Chairman",
        );

        setData(data);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Header />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Chairman's Message </h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/HomeFr"> Home</Link>
            </li>
            <li>|</li>
            <li> Chairman's Message </li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            {data.length > 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`}
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt={data[0].name || "Image"}
                  />
                </LazyLoad>
                <p>
                  <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                </p>
                <p className="name">
                  {data[0].name}
                  <span> {data[0].category} </span>
                </p>
              </div>
            )}

            {data.length === 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/default.jpg"
                    className="img-fluid col-sm-12 col-md-3 float-md-end mb-3 msgimg"
                    alt=""
                  />
                </LazyLoad>
                <p>
                  <b>
                    "There are two educations. One should teach us how to make a
                    living and the other how to live"
                  </b>
                </p>
                <p>
                  Gayatri International School has been conceived with the aim
                  of providing a refreshing approach to school education. It
                  seeks to meet and in fact exceed the expectations of parents
                  and pupils alike. GIS as part of its mission endeavours to
                  provide learners a truly world-class value- based education
                  that gives them a distinct edge in life.
                </p>
                <p>
                  GIS intends to equip students with a comprehensive range of
                  21st century skills to enable them to emerge truly successful
                  at school and in life.
                </p>
                <p>
                  The school has put in place a superior infrastructure with all
                  the modern amenities to enable every learner to turn his/her
                  innate potential into reality. To put it simply, GIS is the
                  place where ‘dreams come true’ as reflected in the motto of
                  the school.
                </p>
                <p>
                  The school is also committed to translating its vision of
                  ‘every child becomes an achiever’ in a caring and nurturing
                  environment. The school intends to achieve the above goals by
                  adopting the progressive CBSE curriculum aided by a modern
                  pedagogy that is a blend of the best practices from around the
                  world.
                </p>
                <p>
                  I am confident that pupils will have ample opportunities to
                  anchor and develop themselves in their chosen areas of
                  interests and most importantly realise their potential
                  completely during their school lives.
                </p>
                <p>Warm Regards </p>

                <p className="name">
                  Mr. Manoj Agarwal <span> Chairman</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ChairmanMessage;
